import { IApiService } from '../../services/ApiService';
import { LoaderFunctionArgs } from 'react-router';
import { handleLoaderError } from '../../services/loaderErrorHandler';
import { Logger } from '../../utils/Logger';

export function mePageLoader(apiService: IApiService) {
  return async ({ request }: LoaderFunctionArgs) => {
    Logger.debug('LOADER', "me page loader starting");
    try {
      const userDetail = await apiService.getUserDetail(request.signal);
      Logger.debug('LOADER', "me page loader completed");
      return { userDetail };
    } catch (error) {
      return handleLoaderError(error, request.url);
    }
  };
}
